<template>
  <router-view />
</template>

<script>
export default {
  name: "app-wallConnection"
};
</script>

<style lang="scss" scoped></style>
